// extracted by mini-css-extract-plugin
module.exports =  {"AvatarGroup":"g2pX4q2DlL22Ys3WBwWA","AvatarGroup__Item":"JqQGh4SVj7uxjpVcqrBo","AvatarGroup__More":"iBiUM8eL4LvYc5rsXZTQ"};